import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { LoadCssResolver } from '@b2b/common/resolvers';
import { SubscriptionsOptOutModalControllerModule } from './detail/controllers/OptOutModalController';
import { SubscriptionsDetailView } from './detail/detail';
import { SubscriptionsListView } from './list/list';

export const SubscriptionsView = angular
  .module('acme.view.application.subscriptions', [
    uiRouter,
    'ui.bootstrap',
    'isteven-multi-select',
    SubscriptionsListView,
    SubscriptionsOptOutModalControllerModule,
    SubscriptionsDetailView,
    'acme.view.application.dataGrid.controllers',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const subscriptions = {
      name: 'application.subscriptions',
      url: '/subscriptions',
      views: {
        'subview-main': {
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/subscriptions/subscriptions.tpl.html',
        },
      },
      data: {
        pageTitle: 'Subscriptions',
        /** Secure With Permissions **/
        // permissions: []
      },

      resolve: {
        istevenMultiselectCss: LoadCssResolver({ id: 'isteven-multi-select', url: '/assets/isteven-multi-select.css' }),
      },
    };

    $stateProvider.state(subscriptions);
  }).name;
